<div
  [ngClass]="{ 'to-top-button--hidden': !isVisible }"
  class="to-top-button"
  (click)="scrollToTop()"
>
  <hdi-button [type]="ButtonType.BACK_TO_TOP" [iconPrefix]="'far'">
  </hdi-button>
</div>
